export default "__VITE_ASSET__CwUPki8T__"